import type { Listing, ListingGrouping, FindAllListingsDTO } from './listing';

// noinspection JSUnusedGlobalSymbols
export enum InteractionType {
  SHARINGS = 'sharings',
}

export enum FeatureType {
  CONTENT = 'content',
}

export interface OneToManySimilarListingsProps {
  listingId: Listing['id'];
  similarityType: InteractionType | FeatureType;
  top_n?: number;
}

export interface MatchNeedsWithOffersProps {
  groupingId?: ListingGrouping['id'] | undefined;
  similarityType: InteractionType | FeatureType;
}

// DTO for one-to-many similarity queries
export type OneToManySimilaritiesQueryDTO = OneToManySimilarListingsProps &
  Pick<FindAllListingsDTO, 'addressIds' | 'groupIds' | 'type'>;
export type ManyToManySimilaritiesQueryDTO = MatchNeedsWithOffersProps &
  Pick<FindAllListingsDTO, 'addressIds' | 'groupIds' | 'type'>;

// DTO for recommendations with similarity type and filters
export interface GetRecommendationsWithSimilarityQueryDTO extends Pick<
  FindAllListingsDTO,
  'addressIds' | 'groupIds' | 'type'
> {
  similarityType: InteractionType | FeatureType;
}

// DTO for recommendations without similarity type (only filters and recommendation type)
export type GetRecommendationsWithoutSimilarityQueryDTO = Omit<
  GetRecommendationsWithSimilarityQueryDTO,
  'similarityType'
>;

// Union type for query key parameters
export type QueryKeyParameters =
  | OneToManySimilaritiesQueryDTO
  | GetRecommendationsWithSimilarityQueryDTO
  | GetRecommendationsWithoutSimilarityQueryDTO;

// Recommended listing type with score and optional strategy
export type RecommendedListing = Listing & {
  score: number;
  strategy?: string;
  from?: string;
};
